module.exports = __webpack_public_path__ + "img/downloadimage.5e0cfa39.svg";